import { useSelector, useDispatch } from "react-redux";
import { setToken } from "../store/slices/token.slice.js";

export default function useToken() {
  const { token } = useSelector((s) => s.tokenSlice);
  const dispatch = useDispatch();

  const newToken = (newToken) => {
    dispatch(setToken(newToken));
  };

  return [token, newToken];
}
